import { chakra, useColorModeValue } from "@chakra-ui/react";
import { ComponentProps } from "react";

import CodeSandboxLogo from "@/common/assets/codesandbox-logo.svg?react";

const ChakraCodeSandboxLogo = chakra(CodeSandboxLogo);

export type CodeSandboxIconProps = ComponentProps<
  typeof ChakraCodeSandboxLogo
> & {
  isDisabled?: boolean;
};

export function CodeSandboxIcon({
  boxSize = 4,
  isDisabled = false,
  ...boxProps
}: CodeSandboxIconProps) {
  const color = useColorModeValue("#222326", "#F4F5F8");

  return (
    <ChakraCodeSandboxLogo
      boxSize={boxSize}
      color={color}
      flexShrink={0}
      opacity={isDisabled ? 0.5 : 1}
      {...boxProps}
    />
  );
}
